// extracted by mini-css-extract-plugin
export default {"signInModalBackdrop":"RegisterPage_signInModalBackdrop__Phs32"};